import React, { ReactElement, useState } from 'react';
import { useTranslation } from 'next-i18next';
import Table from '@components/ui/Table';
import type {
  StoreException,
  StoreHour,
} from '@adapters/prismic/fetching/stores/types';
import Modal from '@components/global/Modal';
import Button from '@components/ui/Button';

import styles from './StoreHours.module.scss';

export const StoreHours = ({
  week,
  exceptions,
}: {
  week: StoreHour[];
  exceptions: StoreException[];
}): ReactElement | null => {
  const { t } = useTranslation('stores');
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!week?.length) return null;

  const tableData = week.map(({ day, open, close, dow_notice }) => [
    t(day),
    <span>
      {open && open}
      {open && close && ' - '}
      {close && close}
      {dow_notice && (
        <>
          <br />
          <em>{dow_notice}</em>
        </>
      )}
    </span>,
  ]);

  const tableExceptionData = exceptions.map(
    ({ date, open, close, name, exception_notice }) => [
      `${t(name)} ${date}`,
      <span>
        {open && open}
        {open && close && ' - '}
        {close && close}
        {exception_notice && (
          <>
            <br />
            <em>{exception_notice}</em>
          </>
        )}
      </span>,
    ]
  );

  const toggleModal = () => setIsModalOpen((state) => !state);
  const heading = [
    <strong>{t('hours')}</strong>,
    <Button
      variant="unstyled"
      size="large"
      handleClick={toggleModal}
      label={t('see.exceptions')}
    />,
  ];

  return (
    <>
      <Table
        classNames={styles.updateHeader}
        headingRow={heading}
        dataRows={tableData}
      />
      <Modal
        isOpen={isModalOpen}
        onClose={toggleModal}
        classNames={styles.modal}
        title={t('exceptions.title') ?? ''}
      >
        <Table dataRows={tableExceptionData} />
      </Modal>
    </>
  );
};

export default StoreHours;
